import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';

import Detalle from './Detalle';
import dialog from "../../../../common/utility/dialog";


const InputGroup = Input.Group;
const { TabPane } = Tabs;

class FormConversion extends React.Component {


  constructor(props) {
    super(props);
  }


  handleOk = (e) => {

    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);

      if (!err) {

        const data = this.fetchReferencias(values);

        const validFormLogic = this.validateFormLogic(data, values);
        if (!validFormLogic) {
          return;
        }

        this.props.onSaveConversion(data, this.props.form);
      }
    });
  };

  validateFormLogic = (data, values) => {
    if (data.length == 0) {
      dialog.warning("Tiene que agregar detalle");
      return false;
    }
    return true;

  };



  fetchReferencias = (values) => {
    var result = [];

    var keys = [];
    var obj = Object.assign({}, values.cantidad);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {
      result.push({
        idProducto: this.props.formValues.id,
        cantidadBase: parseFloat(values.cantidadBase[key]),
        idUnidadMedida: values.idUnidadMedida[key] == undefined ? 0 : values.idUnidadMedida[key].key,
        cantidad: parseFloat(values.cantidad[key]),
      });
    });


    return result;
  };


  render() {


    const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });



    return (
      <Modal
        title={"Conversion de Medida"}
        visible={this.props.visible}
        onCancel={this.props.onClose}
        style={{ top: 30 }}
        width={1000}
        footer={[
          <Button
            key="1"
            onClick={this.props.onClose}
          >
            Cancelar
          </Button>,
          <Button
            key="2"
            type="primary"

            onClick={this.handleOk}
          >
            Guardar
          </Button>
        ]}
      >
        <Form>


          <div className="row">
            <div className="col-md-3">
              <Form.Item label="Codigo Referencia">
                <Input readOnly
                  value={this.props.formValues.codigoReferencia}
                />
              </Form.Item>
            </div>
            <div className="col-md-5">
              <Form.Item label="Producto">
                <Input readOnly
                  value={this.props.formValues.nombre}
                />
              </Form.Item>
            </div>

            <div className="col-md-4">
              <Form.Item label="Unidad de Medida">
                <Input readOnly
                  value={this.props.formValues.nombreUnidadMedida}
                />
              </Form.Item>
            </div>

          </div>
          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                tabBarExtraContent={
                  <div className="custom-options">
                    <Button
                      icon="plus"
                      type="primary"
                      onClick={() => this.props.onAgregarDetalle(this.props.form.setFieldsValue, this.props.form.getFieldValue)}
                    >
                      Agregar
                    </Button>
                  </div>
                }
              >
                <TabPane
                  tab={
                    <span>
                      <Icon type="ordered-list" />
                      Equivalencia
                    </span>
                  }
                  key="1"
                >
                  <Detalle
                    dataSource={this.props.formValues.listaComprobanteDetalle}
                    formValues={this.props.formValues}
                    onRemove={this.props.handleRemoveDetails}
                    onGetFieldDecorator={getFieldDecorator}
                    onSetFieldsValue={setFieldsValue}
                    onGetFieldValue={getFieldValue}
                    unidadMedida={this.props.formValues.nombreUnidadMedida}

                  />
                </TabPane>


              </Tabs>
            </div>
          </div>


        </Form>
      </Modal>
    );
  }
}

export default Form.create()(FormConversion);
